"use strict";
import { createContext } from "react";
import { UniverseChainId } from "features/chains/types";
export const MultichainContext = createContext({
  reset: () => void 0,
  setSelectedChainId: () => void 0,
  isUserSelectedToken: false,
  setIsUserSelectedToken: () => void 0,
  chainId: UniverseChainId.Mainnet,
  initialChainId: UniverseChainId.Mainnet,
  isMultichainContext: false
});
